import { Component } from '@angular/core';

import { BookingActionBaseComponent } from './booking-action.base-component';

@Component({ template: '' })
export abstract class ExplainStorageTimerActionBaseComponent extends BookingActionBaseComponent {}
